// Client-side image helpers for avatar uploads.

/** Allowed image types for an avatar upload (validated again server-side). */
export const IMAGE_ACCEPT = ["image/jpeg", "image/png", "image/webp"];

/** Max ORIGINAL file size accepted client-side before downscaling. */
export const MAX_IMAGE_BYTES = 5 * 1024 * 1024; // 5 MB

/**
 * Center-crop an image File to a square and downscale to `size`px, returned as a compact data URL.
 * Prefers WebP (smaller) and falls back to JPEG where the browser can't encode WebP. Keeps stored
 * avatars tiny (~10–40 KB) regardless of the source image, which is why no object storage is needed —
 * the data URL goes straight into the Employee.avatar TEXT column.
 */
export async function downscaleSquareDataUrl(file, size = 256) {
  const bitmap = await createImageBitmap(file);
  try {
    const side = Math.min(bitmap.width, bitmap.height);
    const sx = (bitmap.width - side) / 2;
    const sy = (bitmap.height - side) / 2;
    const canvas = document.createElement("canvas");
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("Canvas not supported");
    ctx.drawImage(bitmap, sx, sy, side, side, 0, 0, size, size);
    const webp = canvas.toDataURL("image/webp", 0.85);
    return webp.startsWith("data:image/webp") ? webp : canvas.toDataURL("image/jpeg", 0.85);
  } finally {
    bitmap.close?.();
  }
}
